module.exports = __webpack_public_path__ + "img/info_square.bf60cf27.svg";